/** Faixa "dia inteiro" dos prazos de prótese no topo das colunas da agenda. Toda coluna (e a régua
 *  de horários) usa a mesma altura — a do dia com mais pedidos —, senão cada grade começa numa
 *  altura e os horários da esquerda não batem com as linhas. Linha de 18px, 2px entre linhas,
 *  2px de respiro em cima e embaixo e 1px de borda. */
export const ALTURA_DA_LINHA_DA_FAIXA = 18;
export const alturaDaFaixa = (linhas: number) => (linhas > 0 ? linhas * (ALTURA_DA_LINHA_DA_FAIXA + 2) + 3 : 0);
